import { CUSTOM_PERIOD, PERIOD_PRESETS } from '../../lib/period';

export default function PeriodPicker({
  value,
  onChange,
  customStart,
  customEnd,
  onCustomStart,
  onCustomEnd,
  years,
  label,
}) {
  return (
    <div className="period-picker">
      <select
        className="finances-year-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Reporting period"
      >
        {PERIOD_PRESETS.map((p) => (
          <option key={p} value={p}>
            {p}
          </option>
        ))}
        {years.length > 0 && (
          <optgroup label="Full year">
            {years.map((y) => (
              <option key={y} value={String(y)}>
                {y}
              </option>
            ))}
          </optgroup>
        )}
        <option value={CUSTOM_PERIOD}>{CUSTOM_PERIOD}…</option>
      </select>

      {value === CUSTOM_PERIOD && (
        <div className="period-custom">
          <label>
            From
            <input type="date" value={customStart} onChange={(e) => onCustomStart(e.target.value)} />
          </label>
          <label>
            To
            <input type="date" value={customEnd} onChange={(e) => onCustomEnd(e.target.value)} />
          </label>
        </div>
      )}

      {/* Echo the resolved range only when it adds something. "Last quarter"
          needs to resolve to "Q3 2026"; a bare year already reads as itself,
          and repeating it just puts 2026 on screen twice. */}
      {label !== value && <span className="period-resolved">{label}</span>}
    </div>
  );
}
